export default __webpack_public_path__ + "static/media/remodellingBg.4d45abbd.jpg";